// features/intelligence/index.js — DOMAIN INTELLIGENCE ROUTER
// ═══════════════════════════════════════════════════════════
// Two screens, one feature:
//   1. Domain Selector — landing page (renders inside the
//      existing app shell; AppSidebar stays visible at left)
//   2. Domain Briefing — full-screen 6-tab dashboard for a
//      selected domain (auto-collapses AppSidebar so the
//      content has full width)
//
// The state that flips between them lives here so each
// screen stays focused on its own job.
// ═══════════════════════════════════════════════════════════

import { useState } from 'react';
import DomainSelector from './domain-selector';
import DomainBriefing from './domain-briefing';

// styles/intelligence.css is loaded globally via pages/_app.js.

export default function DomainIntelligenceFeature({
  userRecord,
  onNavigateOut,
  onSidebarCollapse,
}) {
  // null = on the selector. string = on a domain's briefing.
  const [selectedDomain, setSelectedDomain] = useState(null);

  if (!selectedDomain) {
    return (
      <DomainSelector
        userRecord={userRecord}
        onSelectDomain={setSelectedDomain}
      />
    );
  }

  return (
    <DomainBriefing
      domainKey={selectedDomain}
      onExitDomain={() => setSelectedDomain(null)}
      onNavigateOut={onNavigateOut}
      onSidebarCollapse={onSidebarCollapse}
    />
  );
}
